<template>
  <div class="AppAside">
    <el-menu :default-active="activeIndex"
             class="el-menu-vertical-demo"
             @open="handleOpen"
             @close="handleClose"
             background-color="#545c64"
             text-color="#fff"
             active-text-color="#ffd04b"
             :router="true">
      <!-- <el-submenu index="/sy">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>首页</span>
        </template>
        <el-menu-item index="/sy/xtsy">
          <span slot="title">系统首页</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>客户档案</span>
        </template>
        <el-menu-item index="/khgl">
          <span slot="title">客户管理</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/htgl">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>合同管理</span>
        </template>
        <el-menu-item index="/sdht">
          <span slot="title">售电合同</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/jyzx">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>交易中心</span>
        </template>
        <el-menu-item index="/jyzx/khjsgl">
          <span slot="title">客户结算管理</span>
        </el-menu-item>
        <el-menu-item index="/jyzx/dlsjsgl">
          <span slot="title">代理商结算管理</span>
        </el-menu-item>
        <el-menu-item index="/jyzx/khdljyjs">
          <span slot="title">客户电力交易管理</span>
        </el-menu-item>
        <el-menu-item index="/jyzx/khdlsbjs">
          <span slot="title">客户电量申报管理</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/dlsgl">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>代理商管理</span>
        </template>
        <el-menu-item index="/dlsgl/dlsjs">
          <span slot="title">代理商结算</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/cwgl">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>财务管理</span>
        </template>
        <el-menu-item index="/cwgl/jsyj">
          <span slot="title">结算依据</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/xtsz">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>系统设置</span>
        </template>
        <el-menu-item index="/xtsz/zhsz">
          <span slot="title">账户设置</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="/qxgl">
        <template slot="title">
          <i class="el-icon-info"></i>
          <span>权限管理</span>
        </template>
        <el-menu-item index="/qxgl/yhlb">
          <span slot="title">用户列表</span>
        </el-menu-item>
        <el-menu-item index="/qxgl/bmgl">
          <span slot="title">部门管理</span>
        </el-menu-item>
        <el-menu-item index="/qxgl/jssq">
          <span slot="title">角色授权</span>
        </el-menu-item>
      </el-submenu> -->
      <el-submenu v-for="(item) in menuList"
                  :key="item.id+''"
                  v-if="item.keepAlive==0"
                  :index='item.path'>
        <template slot="title">
          <img src="@/assets/sy2.png"
               style="margin-right:10px"
               v-show="item.name=='首页'">
          <img src="@/assets/khal.png"
               style="margin-right:10px"
               v-show="item.name=='客户档案'">
          <img src="@/assets/khal.png"
               style="margin-right:10px"
               v-show="item.name=='代理商档案'">
          <img src="@/assets/htgl.png"
               style="margin-right:10px"
               v-show="item.name=='合同管理'">
          <img src="@/assets/jyzx.png"
               style="margin-right:10px"
               v-show="item.name=='交易中心'">
          <img src="@/assets/dlsgl.png"
               style="margin-right:10px"
               v-show="item.name=='代理商管理'">
          <img src="@/assets/cwgl.png"
               style="margin-right:10px"
               v-show="item.name=='财务管理'">
          <img src="@/assets/u93.png"
               style="margin-right:10px"
               v-show="item.name=='系统设置'">
          <img src="@/assets/sz.png"
               style="margin-right:10px"
               v-show="item.name=='权限管理'">
          <img src="@/assets/jyzx.png"
               style="margin-right:10px"
               v-show="item.name=='日志管理'">
          <span>{{item.name}}</span>
        </template>
        <el-menu-item v-for="(item1) in item.children"
                      :key="item1.id+''"
                      v-if="item1.keepAlive==0"
                      @click="xx(item1)"
                      :index='item1.path'>
          <span slot="title">{{item1.name}}</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "AppAside",
  data () {
    return {
      activeIndex: '',
    };
  },
  computed: {
    menuList () {
      return this.$store.state.permissionList.data
    }
  },
  created () {
    if (this.$route.matched[1].path === '/CustomerManagement') {
      this.activeIndex = this.$route.matched[1].path
    }
    else {
      this.activeIndex = this.$route.path
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
    xx (x) {
      localStorage.setItem('parentId', x.id)
    }
  }
};
</script>

<style lang='less' scoped>
</style>
